'use client';

import EarnContainer from './_components';

export default function PointLoungeEarnPage() {
  return <EarnContainer />;
}
